import styled from 'styled-components'

export const CommentSectionContainer = styled.div`
    padding: 0 0 0 27px;
`
export const CommentAligmentItems = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`
export const CommentAligmentButtons = styled.div`
    display: flex;
`
export const ReadMoreButtonStyle = styled.div`
    margin-top: 8px;
    margin-bottom: 24px;
`
export const BottomSeparator = styled.div`
    padding-top: 20px;
    hr {
        border-top: 1px solid rgba(32, 32, 32, 0.1);
    }
`
